import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Constant from "../Utils/Constant";
import BackendConnector from '../Utils/BackendConnector';

const TravelSection = () => {
    const [countries, setCountries] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [displayedTravelsCount, setDisplayedTravelsCount] = useState(Constant.ITEMS_PER_PAGE);
    const navigate = useNavigate();

    // Fonction pour formater la date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', { 
            year: 'numeric', 
            month: 'long' 
        });
    };
    const LoadingSkeleton = () => (
        <div className="row">
            {[...Array(Constant.ITEMS_PER_PAGE)].map((_, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="travel-card loading">
                        <div className="travel-image-container">
                            <div className="loading-shimmer">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">{Constant.LOADING}</span>
                                </div>
                            </div>
                        </div>
                        <div className="travel-content">
                            <div className="placeholder-glow">
                                <span className="placeholder col-6" style={{height: '1rem', borderRadius: '4px'}}></span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    useEffect(() => {
        setIsLoading(true);
        BackendConnector.fetchData('travels/')
            .then(data => {
                // Trier les voyages du plus récent au plus ancien
                const sortedData = data.sort((a, b) => {
                    if (!a.start_date && !b.start_date) return 0;
                    if (!a.start_date) return 1; // Les voyages sans date en dernier
                    if (!b.start_date) return -1;
                    return new Date(b.start_date) - new Date(a.start_date);
                });
                setCountries(sortedData);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Erreur lors du chargement des pays:', error);
                setIsLoading(false);
            });
    }, []);

    return (
        <section id="travels" className="section">
            <div className="travel-section-container">
                <h2>{Constant.MY_TRAVELS}</h2>
                <p className="travel-intro">
                    {Constant.TRAVEL_INTRO}
                </p>

                {isLoading ? (
                    <LoadingSkeleton />
                ) : countries.length === 0 ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="no-travels-message">
                                <div className="no-travels-icon">✈️</div>
                                <h3>{Constant.NO_TRAVELS_AVAILABLE}</h3>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row">
                            {countries.slice(0, displayedTravelsCount).map(country => (
                                <div key={country.id} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                                    <div 
                                        className="travel-card clickable"
                                        onClick={() => navigate(`/travel/${country.id}`)}
                                    >
                                        <div className="travel-image-container">
                                            {country.cover ? (
                                                <img 
                                                    src={country.cover} 
                                                    alt={country.name} 
                                                    className="travel-image"
                                                />
                                            ) : (
                                                <div className="travel-placeholder">
                                                    <i className="fas fa-globe-americas" style={{fontSize: '2rem', color: '#64748b'}}></i>
                                                    <p className="text-muted mb-0 mt-2">{Constant.NO_IMAGE_MESSAGE}</p>
                                                </div>
                                            )}
                                            <div className="travel-overlay">
                                                <div className="travel-info">
                                                    <h5 className="travel-title">{country.flag || '🌍'} {country.name}</h5>
                                                    <div className="travel-action">
                                                        <i className="fas fa-eye"></i>
                                                        <span>{Constant.EXPLORE_TRAVEL}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Badge de date en overlay */}
                                            {country.start_date && (
                                                <div className="travel-date-badge">
                                                    {formatDate(country.start_date)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {countries.length > displayedTravelsCount && (
                            <div className="row">
                                <div className="col-12 text-center mt-4">
                                    <button 
                                        className="btn-view"
                                        onClick={() => setDisplayedTravelsCount(prev => prev + Constant.ITEMS_PER_PAGE)}
                                    >
                                        {Constant.SHOW_MORE_ALBUMS}
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    );
}

export default TravelSection;
